import {createTheme} from "@mui/material/styles";
import styled from "@emotion/styled";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import React from "react";

export const theme = createTheme({
    components:{
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: {
                      modal: 10
                    },
                    background: "transparent",
                }
            }
        }
    }
});

export const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.9rem', height: '40px'}}/>}
        {...props}
    />
))(() => ({
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
}));

export const modalTheme = createTheme({
    components: {
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: {
                        modal: 1200
                    }
                }
            }
        }
    }
});


